import { connect } from 'react-redux';
import { checkAuth } from 'core/slices/users';
import AuthInitializer from '../../../components/providers/AuthInitializer';

export default connect(
  null,
  { checkAuth }
)(AuthInitializer); 